<template>
  <div>
    <v-select style="width: 200px;" :items="languages" v-model="selectedLanguage" item-text="title" item-value="key"
      outlined dense hide-details></v-select>
  </div>
</template>

<script>

/**
 * Component LanguagePicker.vue
 *
 * @module LanguagePicker
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/Language/LanguagePicker.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export default {
  name: "LanguagePicker",
  data: function () {
    return {
      selectedLanguage: this.$app.translationManager.getCurrentLanguage(),
      languages: [
        { "key": 'de', "title": 'Deutsch' },
        { "key": 'en', "title": 'English' },
        { "key": "es", "title": "Español" },
        { "key": "el", "title": "Ελληνικά" },
        { "key": "it", "title": "Italiano" },
        { "key": "nl", "title": "Nederlands" },
        { "key": "pl", "title": "Polska" },
        { "key": "pt", "title": "Português" },
        { "key": "fi", "title": "Suomi" },
        // { "key": "sk", "title": "Slovenčina" },
      ],
    };
  },
  created() {
  },
  computed: {
  },
  watch: {
    async selectedLanguage() {
      // First get a fresh token to be sure we can ask the language files
      const refresh = await this.$app.authentication.refreshToken();

      if (refresh.error) {
        return this.$toasted.show(refresh.error, {
          type : 'error',
          icon : 'error_outline',
          position: 'bottom-center',
          duration : 10000
        })
      }

      this.$app.translationManager.clearLoadedLanguages();
      await this.$app.translationManager.loadLanguages([this.selectedLanguage, 'en']);

      this.$emit('changeLanguage')
      this.$app.eventBus.$emit('changeLanguage', this.selectedLanguage);
      this.$app.translationManager.setCurrentLanguage(this.selectedLanguage);
    },
  },
};
</script>